import Button from 'components/dashboard/forms/button/Button';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

export const MockDetails = () => {
   const navigate = useNavigate()
    const location = useLocation();
    const { mockData } = location.state || {}; // Retrieve the passed data
    console.log(mockData)
    const handleStartExam = () => {
      // Navigate to the Exam page and pass the mockData or any needed info
      navigate('../mock-test/mock-details/exam', { state: { mockData } });
    };

  return (
    <div className="flex md:flex-row flex-col gap-12 p-8 w-full mt-12 ">
   <div className='bg-white/40 flex md:flex-row flex-col gap-12 w-full p-6 rounded-md'>
   <div
      className="md:w-1/3 w-full  bg-white p-3 rounded-md cursor-pointer flex shadow-sm flex-col gap-2"
    >
      <div className="rounded-lg relative">
        <img
          src={mockData.img}
          alt="course-img"
          className="h-[113px] w-full object-cover rounded-lg"
        />
        
      </div>
      <button className="bg-primary  w-fit px-2 py-1 text-blueColor text-[8px] font-medium rounded-sm">
        {mockData.dept}
      </button>
   
      <p className="font-semibold text-[14px] leading-[20px]">{mockData.text}</p>

    
      <div className="flex gap-4">
        <div>
          <div className="w-6 h-6 rounded-full">
            <img
              src={mockData.profileImg}
              alt="profile"
              className="w-full h-full object-cover rounded-full"
            />
          </div>
        </div>
        <div className="flex flex-col justify-between text-[8px]">
          <h2 className="text-neutral font-semibold">{mockData.instructorName}</h2>
          <p>Tutor</p>
        </div>
      </div>
    </div>
    <div className='md:w-2/3 w-full flex flex-col gap-6'>
    <div className=" w-fit">
                    <Button onClick={handleStartExam}>Start Exam</Button>
                </div>
    </div>
   </div>
  </div>
  )
}
